jQuery.event.special.touchstart = {
  setup: function( _, ns, handle ) {
      this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
  }
};
jQuery.event.special.touchmove = {
  setup: function( _, ns, handle ) {
      this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
  }
};

jQuery(document).ready(function ($) {

  // SLIDER
  $(".reviews").slick({
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
    lazyLoad: 'ondemand',
    responsive: [
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

  // ADVANTAGES
  if (window.matchMedia("(max-width: 576px)").matches) {
    $(".advantages").slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: false,
      fade: true,
    });
  }

  // PHONE MASK
  $(function () {
    $("input[type='tel']").mask("+38(000)000-00-00", {
      placeholder: "+38(XXX)XXX-XX-XX",
      clearIfNotMatch: true,
    });
  });

  // FILE UPLOAD
  $(".input-file").each(function () {
    var $input = $(this),
      $label = $input.next(".js-labelFile"),
      labelVal = $label.html();

    $input.on("change", function (element) {
      var fileName = "";
      if (element.target.value)
        fileName = element.target.value.split("\\").pop();
      fileName
        ? $label.addClass("has-file").find(".js-fileName").html(fileName)
        : $label.removeClass("has-file").html(labelVal);
    });
  });

  // SUCCESS MESSAGE
  document.addEventListener("wpcf7mailsent",
    function (event) {
         $('.modal').removeClass('active');
         $('body').css('overflow-y', 'hidden');
         $('.modal-overlay').addClass('active');
         $('#success').addClass('active');
    },
    false
  );

  // HAMBURGER MENU
  $(".hamburger").click(function (e) {
    e.preventDefault();
    $(this).toggleClass("is-active");
    $(".modal-overlay").toggleClass("active");
    $(".header").toggleClass("active");
    $("body").css("overflow-y", "hidden");
    if (!$(".hamburger").hasClass("is-active")) {
      $("body").css("overflow-y", "auto");
      $(".mobile-topbar").css({ "z-index": "300" });
    }
    $(".mobile-topbar").css({ "z-index": "300" });
  });

  // MODAL WINDOWS
  $("a.btn--modal").click(function (e) {
    e.preventDefault();
    $("body").css("overflow-y", "hidden");
    var modal = $(this).attr("href");
    $(".modal-overlay").addClass("active");
    $(modal).addClass("active");
    $(".mobile-topbar").css({ "z-index": "200" });
    if (
      $(".header").hasClass("active") &&
      $(".hamburger").hasClass("is-active")
    ) {
      $("header").removeClass("active");
      $(".hamburger").removeClass("is-active");
    }
  });

  $(".modal__close").click(function (e) {
    e.preventDefault();
    $(".mobile-topbar").css({ "z-index": "300" });
    $(".modal.active").removeClass("active");
    $(".modal-overlay").removeClass("active");
    $("body").css("overflow-y", "auto");
    $(".hamburger").removeClass("is-active");
  });

  $(this).keydown(function (e) {
    if (e.which == 27) {
      $(".modal-overlay").removeClass("active");
      $(".modal.active").removeClass("active");
      $("body").css("overflow-y", "auto");
    }
  });

});
